import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { ArrowRight } from "lucide-react";

interface Insight {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  published_at: string | null;
  author_name: string | null;
}

const useInsights = (limit?: number) => {
  const [insights, setInsights] = useState<Insight[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      let query = supabase
        .from("insights")
        .select("id, title, slug, excerpt, published_at, author_name")
        .order("published_at", { ascending: false });
      if (limit) query = query.limit(limit);
      const { data } = await query;
      setInsights((data as Insight[]) || []);
      setLoading(false);
    };
    fetch();
  }, [limit]);

  return { insights, loading };
};

export { useInsights };
export type { Insight };
